(function () {
  /*
   * Zeitzone & Umfang dieser Datei
   *
   * Bestellschluss (orderCutOffTime) und „nächster Versandtag“ gelten in SHOP_TIME_ZONE
   * (Europe/Berlin): Feiertage, Wochenende und Urlaub beziehen sich auf den Kalender dort.
   *
   * Anzeige (z. B. „Vor … Uhr bestellt“, Countdown) nutzt den so ermittelten echten
   * Zeitpunkt (UTC-intern) und formatiert ihn mit formatLocalTimeHm in der lokalen
   * Uhrzeit des Browsers – z. B. 14:00 Berlin → 13:00 in London (bei MEZ vs. GMT).
   *
   * Der größere Code-Umfang kommt daher, dass es in reinem Browser-JS kein
   * „14:00 Europe/Berlin an Datum X“ in einer Zeile gibt (zonedWallClockToDate) und
   * „heute/morgen“ für Promo/Timer am Berlin-Datum hängen muss – nicht von einer
   * simplen ±-Stunden-Konstante pro Land (Halbstunden, DST, andere Zonen).
   *
   * Markup (snippets/delivery-estimation.liquid): .delivery-field.left und .delivery-field.right
   * sind untereinander gestapelt (eine Spalte), nicht nebeneinander – mobil und Desktop.
   */
  const orderCutOffTime = 14;
  /** Geschäftszeitzone für Bestellschluss und Versandkalender */
  const SHOP_TIME_ZONE = 'Europe/Berlin';

  const nationalHolidays = [
    { month: 1, day: 1 },
    { month: 4, day: 3 },
    { month: 4, day: 6 },
    { month: 5, day: 1 },
    { month: 5, day: 14 },
    { month: 5, day: 25 },
    { month: 10, day: 3 },
    { month: 12, day: 25 },
    { month: 12, day: 26 },
  ];

  const nrwHolidays = [
    { month: 6, day: 4 },
    { month: 11, day: 1 },
    { month: 12, day: 24 },
    { month: 12, day: 31 },
  ];

  const vacationPeriods = [{ start: '2024-12-10', end: '2024-12-14' }];

  function isVacationYmd(y, mo, d) {
    const dateString = `${y}-${String(mo).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
    return vacationPeriods.some(
      (period) => dateString >= period.start && dateString <= period.end
    );
  }

  function berlinYmdHm(date) {
    const fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: SHOP_TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
    const p = fmt.formatToParts(date);
    const g = (t) => p.find((x) => x.type === t)?.value;
    return {
      y: +g('year'),
      mo: +g('month'),
      d: +g('day'),
      h: +g('hour'),
      min: +g('minute'),
    };
  }

  function berlinCalendarKey(y, mo, d) {
    return y * 10000 + mo * 100 + d;
  }

  /**
   * UTC-Moment, an dem in timeZone die Uhr hour:minute am Kalendertag y-mo-d zeigt.
   */
  function zonedWallClockToDate(y, mo, d, hour, minute, timeZone) {
    const fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
    function matches(ms) {
      const parts = fmt.formatToParts(new Date(ms));
      const get = (t) => +parts.find((x) => x.type === t).value;
      return (
        get('year') === y &&
        get('month') === mo &&
        get('day') === d &&
        get('hour') === hour &&
        get('minute') === minute
      );
    }
    const anchor = Date.UTC(y, mo - 1, d, 0, 0, 0);
    for (let ms = anchor - 14 * 3600000; ms < anchor + 38 * 3600000; ms += 60000) {
      if (matches(ms)) return new Date(ms);
    }
    return new Date(anchor);
  }

  function berlinWeekdaySun0(y, mo, d) {
    const inst = zonedWallClockToDate(y, mo, d, 12, 0, SHOP_TIME_ZONE);
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: SHOP_TIME_ZONE,
      weekday: 'short',
    }).formatToParts(inst);
    const w = parts.find((p) => p.type === 'weekday')?.value;
    const map = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return map[w] ?? 0;
  }

  function isNonShipDayBerlin(y, mo, d) {
    const wd = berlinWeekdaySun0(y, mo, d);
    if (wd === 0 || wd === 6) return true;
    if (nationalHolidays.some((h) => h.month === mo && h.day === d)) return true;
    if (nrwHolidays.some((h) => h.month === mo && h.day === d)) return true;
    if (isVacationYmd(y, mo, d)) return true;
    return false;
  }

  /** Zustell-Logik wie im Original: nur Sonntag ausgeschlossen, keine NRW-Zusatzfeiertage. */
  function isBlockedDeliveryDayBerlin(y, mo, d) {
    if (berlinWeekdaySun0(y, mo, d) === 0) return true;
    if (nationalHolidays.some((h) => h.month === mo && h.day === d)) return true;
    if (isVacationYmd(y, mo, d)) return true;
    return false;
  }

  function addBerlinCalendarDays(y, mo, d, delta) {
    const base = zonedWallClockToDate(y, mo, d, 12, 0, SHOP_TIME_ZONE);
    return berlinYmdHm(new Date(base.getTime() + delta * 86400000));
  }

  /**
   * Uhrzeit eines Date in der lokalen Zeitzone des Clients (Anzeige).
   */
  function formatLocalTimeHm(date) {
    const parts = new Intl.DateTimeFormat('de-DE', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(date);
    let hh = '';
    let mm = '';
    for (let i = 0; i < parts.length; i++) {
      if (parts[i].type === 'hour') hh = parts[i].value;
      if (parts[i].type === 'minute') mm = parts[i].value;
    }
    return `${hh}:${mm}`;
  }

  /** Gleiche Kachelhöhe auf Desktop (≥601px), wenn beide Felder sichtbar sind. */
  function syncDeliveryFieldHeights() {
    const section = document.querySelector('.delivery-estimation-section');
    const row = section && section.querySelector('.delivery-row');
    if (!row) return;

    const clearMinHeights = () => {
      row.querySelectorAll('.delivery-field').forEach((el) => {
        el.style.minHeight = '';
      });
    };

    if (
      typeof window.matchMedia === 'function' &&
      !window.matchMedia('(min-width: 601px)').matches
    ) {
      clearMinHeights();
      return;
    }

    const fields = Array.from(row.querySelectorAll('.delivery-field')).filter(
      (el) => !el.hidden
    );
    clearMinHeights();
    if (fields.length < 2) return;

    const heights = fields.map((el) => el.getBoundingClientRect().height);
    const maxH = Math.max(...heights);
    if (maxH <= 0) return;
    fields.forEach((el) => {
      el.style.minHeight = `${maxH}px`;
    });
  }

  let syncHeightsRaf = 0;
  function scheduleSyncDeliveryFieldHeights() {
    if (syncHeightsRaf) cancelAnimationFrame(syncHeightsRaf);
    syncHeightsRaf = requestAnimationFrame(() => {
      syncHeightsRaf = 0;
      syncDeliveryFieldHeights();
      requestAnimationFrame(syncDeliveryFieldHeights);
    });
  }

  function run() {
    const currentDate = new Date();

    const timerInCardEl = document.getElementById('today-ordered-timer-in-card');
    const estimatedEl = document.getElementById('estimated-delivery');
    const promoEl = document.getElementById('today-ordered-promo');
    const promoMainEl = document.getElementById('today-ordered-promo-main');
    const promoSubEl = document.getElementById('today-ordered-promo-sub');
    const hasPromo = promoEl && promoMainEl && promoSubEl;
    const todayColumnEl = document.getElementById('today-ordered-column');
    const headlineEl = document.getElementById('today-ordered-headline');
    const leftFieldEl = document.getElementById('delivery-estimation-left-field');

    if (!timerInCardEl || !estimatedEl) {
      return;
    }

    const oc = Number(orderCutOffTime);
    const cutoffH = Math.floor(oc);
    const cutoffMin = ((Math.round((oc - cutoffH) * 60) % 60) + 60) % 60;

    const bp = berlinYmdHm(currentDate);
    const nowMinBerlin = bp.h * 60 + bp.min;
    const cutoffMinBerlin = cutoffH * 60 + cutoffMin;

    let candidateY;
    let candidateMo;
    let candidateD;

    if (nowMinBerlin < cutoffMinBerlin && !isNonShipDayBerlin(bp.y, bp.mo, bp.d)) {
      candidateY = bp.y;
      candidateMo = bp.mo;
      candidateD = bp.d;
    } else {
      const n = addBerlinCalendarDays(bp.y, bp.mo, bp.d, 1);
      candidateY = n.y;
      candidateMo = n.mo;
      candidateD = n.d;
    }

    while (isNonShipDayBerlin(candidateY, candidateMo, candidateD)) {
      const n = addBerlinCalendarDays(candidateY, candidateMo, candidateD, 1);
      candidateY = n.y;
      candidateMo = n.mo;
      candidateD = n.d;
    }

    let nextShippingDay = zonedWallClockToDate(
      candidateY,
      candidateMo,
      candidateD,
      cutoffH,
      cutoffMin,
      SHOP_TIME_ZONE
    );

    if (nextShippingDay.getTime() <= currentDate.getTime()) {
      let n = addBerlinCalendarDays(candidateY, candidateMo, candidateD, 1);
      candidateY = n.y;
      candidateMo = n.mo;
      candidateD = n.d;
      while (isNonShipDayBerlin(candidateY, candidateMo, candidateD)) {
        n = addBerlinCalendarDays(candidateY, candidateMo, candidateD, 1);
        candidateY = n.y;
        candidateMo = n.mo;
        candidateD = n.d;
      }
      nextShippingDay = zonedWallClockToDate(
        candidateY,
        candidateMo,
        candidateD,
        cutoffH,
        cutoffMin,
        SHOP_TIME_ZONE
      );
    }

    const endOfOrderDayLocal = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      23,
      59,
      0,
      0
    );
    const orderByMidnightLabel = formatLocalTimeHm(endOfOrderDayLocal);

    const timeUntilNextShipment = nextShippingDay - currentDate;
    const hoursUntilNextShipment = Math.floor(
      timeUntilNextShipment / (1000 * 60 * 60)
    );
    const minutesUntilNextShipment = Math.floor(
      (timeUntilNextShipment % (1000 * 60 * 60)) / (1000 * 60)
    );

    const todayKey = berlinCalendarKey(bp.y, bp.mo, bp.d);
    const shipParts = berlinYmdHm(nextShippingDay);
    const shipKey = berlinCalendarKey(shipParts.y, shipParts.mo, shipParts.d);
    const tmr = addBerlinCalendarDays(bp.y, bp.mo, bp.d, 1);
    const tomorrowKey = berlinCalendarKey(tmr.y, tmr.mo, tmr.d);

    const hideJetztBestelltTile =
      shipKey !== todayKey && shipKey !== tomorrowKey;

    let timerText = '';
    let showPromoInTile = false;
    let showTimerInCard = false;

    if (shipKey !== todayKey && shipKey !== tomorrowKey) {
      timerText = '';
    } else if (shipKey === todayKey) {
      if (hoursUntilNextShipment === 0) {
        const minuteLabel =
          minutesUntilNextShipment === 1 ? 'Minute' : 'Minuten';
        timerText = `⏳ Garantierter Versand in <span class="delivery-estimation-timer-in-card__time">${minutesUntilNextShipment} ${minuteLabel}</span>`;
      } else {
        timerText = `⏳ Garantierter Versand in <span class="delivery-estimation-timer-in-card__time">${hoursUntilNextShipment}h\u00A0${minutesUntilNextShipment}min</span>`;
      }
      showTimerInCard = true;
    } else if (shipKey === tomorrowKey) {
      if (hasPromo) {
        showPromoInTile = true;
        timerText = '';
      } else {
        timerText = `⏳ Vor ${orderByMidnightLabel} Uhr bestellt, morgen <strong>garantiert versendet</strong>`;
        showTimerInCard = true;
      }
    }

    if (hasPromo) {
      if (showPromoInTile) {
        promoMainEl.innerHTML = `<strong>Vor ${orderByMidnightLabel} Uhr bestellt</strong>`;
        promoSubEl.textContent = 'Morgen garantiert versendet!';
        promoEl.hidden = false;
      } else {
        promoMainEl.innerHTML = '';
        promoSubEl.textContent = '';
        promoEl.hidden = true;
      }
    }

    const promoOnlyLayout = !!(hasPromo && showPromoInTile);

    if (headlineEl) {
      if (promoOnlyLayout) {
        headlineEl.hidden = true;
      } else {
        headlineEl.hidden = false;
        const strong = headlineEl.querySelector('strong');
        if (strong) {
          if (showTimerInCard && timerText) {
            if (shipKey === todayKey) {
              strong.textContent = `Vor ${formatLocalTimeHm(nextShippingDay)} Uhr bestellt`;
            } else {
              strong.textContent = `Vor ${orderByMidnightLabel} Uhr bestellt`;
            }
          } else {
            strong.textContent = 'Jetzt bestellt';
          }
        }
      }
    }

    if (todayColumnEl) {
      todayColumnEl.classList.toggle(
        'delivery-estimation-today-col--promo-only',
        promoOnlyLayout
      );
    }

    if (showTimerInCard && timerText) {
      timerInCardEl.innerHTML = timerText;
      timerInCardEl.hidden = false;
    } else {
      timerInCardEl.innerHTML = '';
      timerInCardEl.hidden = true;
    }

    let dEst = addBerlinCalendarDays(shipParts.y, shipParts.mo, shipParts.d, 1);
    while (isBlockedDeliveryDayBerlin(dEst.y, dEst.mo, dEst.d)) {
      dEst = addBerlinCalendarDays(dEst.y, dEst.mo, dEst.d, 1);
    }
    const estimatedDeliveryStart = zonedWallClockToDate(
      dEst.y,
      dEst.mo,
      dEst.d,
      12,
      0,
      SHOP_TIME_ZONE
    );

    let dEnd = { ...dEst };
    let deliveryDaysCount = 1;
    while (deliveryDaysCount < 3) {
      dEnd = addBerlinCalendarDays(dEnd.y, dEnd.mo, dEnd.d, 1);
      if (!isBlockedDeliveryDayBerlin(dEnd.y, dEnd.mo, dEnd.d)) {
        deliveryDaysCount++;
      }
    }
    const estimatedDeliveryEnd = zonedWallClockToDate(
      dEnd.y,
      dEnd.mo,
      dEnd.d,
      12,
      0,
      SHOP_TIME_ZONE
    );

    const formattedStartDate = `${estimatedDeliveryStart.toLocaleDateString(
      'de-DE',
      { weekday: 'long' }
    )} (${estimatedDeliveryStart
      .toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' })
      .replace(/(\d+)\.$/, '$1')})`;

    const formattedEndDate = `${estimatedDeliveryEnd.toLocaleDateString(
      'de-DE',
      { weekday: 'long' }
    )} (${estimatedDeliveryEnd
      .toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' })
      .replace(/(\d+)\.$/, '$1')})`;

    estimatedEl.textContent = `${formattedStartDate} - ${formattedEndDate}`;

    if (leftFieldEl) {
      leftFieldEl.hidden = hideJetztBestelltTile;
      const sectionRoot = leftFieldEl.closest('.delivery-estimation-section');
      if (sectionRoot) {
        sectionRoot.classList.toggle(
          'delivery-estimation-section--single-card',
          hideJetztBestelltTile
        );
      }
    }

    scheduleSyncDeliveryFieldHeights();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  let resizeT;
  window.addEventListener('resize', () => {
    clearTimeout(resizeT);
    resizeT = setTimeout(scheduleSyncDeliveryFieldHeights, 120);
  });
})();
